import { loadStripe } from '@stripe/stripe-js';

// Single Stripe.js instance for the whole app, loaded lazily. The POS card flow
// is OPTIONAL: when REACT_APP_STRIPE_PUBLISHABLE_KEY is unset, getStripe()
// returns null and the Pay dialog hides the Card tab (cash still works).
const PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

let stripePromise = null;

export const isStripeConfigured = () => Boolean(PUBLISHABLE_KEY);

export const getStripe = () => {
  if (!PUBLISHABLE_KEY) return null;
  if (!stripePromise) {
    stripePromise = loadStripe(PUBLISHABLE_KEY);
  }
  return stripePromise;
};
